import { Box } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

export default function AspectClearableLabel({
  label,
  isSelected,
  onClear,
}: {
  label: React.ReactNode;
  isSelected: boolean;
  onClear?: () => void;
}) {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
      }}
    >
      {label}
      {isSelected && (
        <ClearIcon
          onClick={(e) => {
            if (onClear) {
              e.stopPropagation();
              onClear();
            }
          }}
          sx={{
            backgroundColor: "grey.300",
            borderRadius: "100px",
            padding: 0.25,
            marginRight: -1.5,
            cursor: "pointer",
          }}
        />
      )}
    </Box>
  );
}
